// Shared auth form validators. Return an error message string, or null when valid.
export function validateRequired(value) {
  return value && String(value).trim() ? null : "Required";
}

export function validateEmail(email) {
  return email && email.includes("@") ? null : "Valid email required";
}

export function validatePassword(password, { min = 8 } = {}) {
  if (!password) return "Password is required.";
  if (password.length < min) return `Password must be at least ${min} characters.`;
  return null;
}

// Full complexity policy — kept in lockstep with the backend
// (entreprise-backend/src/utils/password-policy.ts). Returns the first unmet-rule
// message, or null when valid. Used where we enforce strong passwords (reset flow).
export function validatePasswordPolicy(password) {
  if (!password || password.length < 8) return "Password must be at least 8 characters.";
  if (!/[A-Z]/.test(password)) return "Password must contain an uppercase letter.";
  if (!/[a-z]/.test(password)) return "Password must contain a lowercase letter.";
  if (!/[0-9]/.test(password)) return "Password must contain a number.";
  return null;
}

export function validatePasswordMatch(password, confirm) {
  return password === confirm ? null : "Passwords do not match.";
}
